import { Component, Input, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { debouncedSearch } from 'shared/utils/rx-operators';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { CustomerModel } from '../../../../customer/customer.model';
import { BulkPaymentMatch } from '../../../models/bulk-payment.model';

@Component({
  selector: 'app-customer-selector-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule
  ],
  templateUrl: './customer-selector-modal.component.html'
})
export class CustomerSelectorModalComponent implements OnInit {
  @Input() data: any;

  selectedCustomer: CustomerModel | null = null;
  searchTerm: string = ''; // Bound to the input for display
  filterTerm: string = ''; // Debounced value the filter reads
  searchTerm$ = new Subject<string>();
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    console.log('CustomerSelectorModal initialized with full data:', this.data);
    console.log('Actual modal data:', this.data?.data);
    console.log('Customers:', this.data?.data?.customers);
    console.log('Customers count:', this.data?.data?.customers?.length || 0);

    this.searchTerm$
      .pipe(debouncedSearch(), takeUntilDestroyed(this.destroyRef))
      .subscribe((v) => (this.filterTerm = v));
  }

  get filteredCustomers(): CustomerModel[] {
    // The modal service nests the data under data.data
    const allCustomers: CustomerModel[] = this.data?.data?.customers || [];
    const search = this.filterTerm.toLowerCase().trim();
    
    if (!search) {
      return allCustomers;
    }

    return allCustomers.filter((customer: CustomerModel) => {
      const displayName = customer.displayName?.toLowerCase() || '';
      const companyName = customer.companyName?.toLowerCase() || '';
      const accountNumber = customer.companyAccountNumber?.toLowerCase() || '';
      
      return displayName.includes(search) || 
             companyName.includes(search) || 
             accountNumber.includes(search);
    });
  }

  getCustomerDisplay(customer: CustomerModel): string {
    const name = customer.displayName || customer.companyName || 'Unknown';
    const account = customer.companyAccountNumber ? ` (${customer.companyAccountNumber})` : '';
    return name + account;
  }

  isValidSelection(): boolean {
    return this.selectedCustomer !== null;
  }
}

